export enum PastAndOrFuture {
    TodayOrPast = "today-or-past",
    TodayOrFuture = "today-or-future",
    All = "all",
}
